import React from 'react';
import { Icon } from 'antd';
import Button from 'Components/Shared/Button/Button';
import Spinner from 'Components/Shared/Spinner/Spinner';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import WarningWrapper from 'Components/Shared/WarningWrapper/WarningWrapper';
import FormCustomerTerms from 'Components/FormCustomerTerms/FormCustomerTerms';
import PickPaymentContainer from 'Components/PickPayment/PickPaymentContainer';
import FetchFailureMessage from 'Components/Shared/FetchFailureMessage/FetchFailureMessage';
import OrderItemSummaryContainer from 'Components/OrderItemSummary/OrderItemSummaryContainer';

interface IProps {
  isFetching: boolean;
  isFetchFailed: boolean;
  isShowingWarning: boolean;
  isPaymentSet: boolean;
  isOrderEmpty: boolean;
  onNext: () => void;
  onBack: () => void;
  onCustomerTermsChange: (isApproved: boolean) => void;
}

const OrderPaymentPage: React.SFC<IProps> = ({ 
  isFetching,
  isFetchFailed,
  isShowingWarning,
  isPaymentSet,
  isOrderEmpty,
  onNext,
  onBack,
  onCustomerTermsChange,
}) => {

  if (isFetching) {
    return <Spinner height='lg' />;
  }

  if (isFetchFailed) {
    return (
      <WrapperBox>
        <FetchFailureMessage />
      </WrapperBox>
    );
  }

  if (isOrderEmpty) {
    return (
      <WrapperBox>
        <FormattedText
          displayName={
            `Kunde inte hitta några biljetter... 
            Försök gärna igen om en stund.`
          }
          formattedName='order.message.noreservations'
        />
      </WrapperBox>
    );
  }

  return (
    <>
      <OrderItemSummaryContainer />
      <PickPaymentContainer />
      <WrapperBox>
        <FormattedText 
          style='title' 
          displayName='Köpvillkor'
          formattedName='order.terms.header'
        />
        <FormCustomerTerms onChange={ onCustomerTermsChange } />
      </WrapperBox>
      
      <div className='order-layout-footer'>
        <Button color='transparent' onClick={ onBack }>
          <Icon type='left' />
          <FormattedText
            displayName='Tillbaka'
            formattedName='order.button.previous'
          />
        </Button>
        <WarningWrapper
          isShowingWarning={ isShowingWarning }
          displayName={ 
            isPaymentSet ? 
            'Godkänn villkoren' : 
            'Välj betalsätt' 
          }
          formattedName={ 
            isPaymentSet ? 
            'order.terms.warning' : 
            'order.payment.warning' 
          }
        >
          <Button onClick={ onNext }>
            <FormattedText
              displayName='Genomför köp'
              formattedName='order.button.finish'
            />
            <Icon type='right' />
          </Button>
        </WarningWrapper>
      </div>
    </>
  );
};

export default OrderPaymentPage;


// WEBPACK FOOTER //
// ./src/pages/OrderPaymentPage/OrderPaymentPage.tsx